import { GeoIPInfo } from '../types';

export const BASE_URL = import.meta.env.VITE_APP_API_BASE_URL as string;

export const getGeoInfoByIP = (): Promise<GeoIPInfo> => {
  return fetch(`${BASE_URL}/location`).then(res => res.json());
};
